interface ProdukteTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  tabs: string[];
}

const ProductTabs = ({ activeTab, setActiveTab, tabs }: ProdukteTabsProps) => {
  return (
    <div className="produkte-page__tabs" role="tablist">
      {tabs.map((tab) => {
        const isActive = activeTab === tab;
        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`produkte-page__tab${
              isActive ? " produkte-page__tab--active" : ""
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
};

export default ProductTabs;
